/*
 * assets/ce-cookie-settings.js — <ce-cookie-settings>
 *
 * Der Footer-Schalter "Cookie-Einstellungen" (§ 25 TDDDG: die Einwilligung muss jederzeit
 * so leicht widerrufbar sein, wie sie erteilt wurde). Er oeffnet keinen eigenen Dialog —
 * der Consent-Dialog gehoert nicht ins Theme, sondern in die Shopify-Customer-Privacy-API
 * bzw. eine CMP (02-theme-architecture.md §9.4, 03-rechtliche-anforderungen.md §6.5).
 * Dieses Element ruft nur den fremden Dialog auf.
 *
 * Warum ein eigenes Element und keine Zeile in theme.js: theme.js enthaelt per §3.2
 * kein Verhalten, und §3.1/§4.5 verlangen ein autonomes Custom Element je Verhalten,
 * dessen Dateiname dem Tag entspricht. Das Skript wird aus snippets/legal-links.liquid
 * eingebunden; Module werden pro URL genau einmal ausgewertet, Mehrfach-Einbindung
 * ist also unkritisch.
 *
 * Ohne JS bleibt der Schalter sichtbar, aber wirkungslos — deshalb data-fallback-url
 * auf die Datenschutzseite: kein toter Pflichtpunkt.
 */

class CECookieSettings extends window.CE.Element {
  setup(signal) {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.open(), { signal });
  }

  open() {
    // 1. Shopify-Consent-Banner ist bereits geladen.
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    // 2. Aeltere/abweichende API-Oberflaeche derselben Funktion.
    if (typeof window.Shopify?.customerPrivacy?.showPreferences === 'function') {
      window.Shopify.customerPrivacy.showPreferences();
      return;
    }

    // 3. API nachladen und erneut versuchen.
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && typeof window.privacyBanner?.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
          return;
        }
        this.fallback();
      });
      return;
    }

    this.fallback();
  }

  /** Keine Consent-API im Shop aktiv: zur Datenschutzseite statt ins Leere. */
  fallback() {
    const url = this.dataset.fallbackUrl;
    if (url) window.location.assign(url);
  }
}

customElements.define('ce-cookie-settings', CECookieSettings);
